import { render, staticRenderFns } from "./BankWithdrawForm.vue?vue&type=template&id=52b2241d"
import script from "./BankWithdrawForm.vue?vue&type=script&lang=js"
export * from "./BankWithdrawForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports